import React, { memo } from 'react';
import { formatAmount, formatDate } from '../utils/helper'; // Import format functions
import { Link, useNavigate } from 'react-router-dom';

const SortableHeader = ({ children }) => (
  <div className="flex items-center gap-2 cursor-pointer hover:text-gray-700">
    {children}
  </div>
);

const LoansTable = ({ loans, loading, filters,isApplication }) => {
  const startIndex = (filters.page - 1) * filters.limit;
  const navigate = useNavigate();

  return (
    <div className="rounded-lg border border-gray-200 overflow-scroll">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>S.No</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>{isApplication?"Application Id":"Loan Id"}</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>Customer</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>{isApplication?"Application Date":"Disbursal Date"}</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>Amount</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>Status</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>Repayment Date</SortableHeader>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <SortableHeader>Action</SortableHeader>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading ? (
            <tr>
              <td colSpan={6} className="px-6 py-10 text-center">
                <div className="flex justify-center">
                  <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </td>
            </tr>
          ) : loans?.length === 0 ? (
            <tr>
              <td colSpan={6} className="px-6 py-10 text-center text-gray-500">
                No loans found
              </td>
            </tr>
          ) : (
            loans?.map((loan, index) => (
              <tr key={loan.loanId} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {startIndex + index + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                <Link className="underline" to={ `/loans/${ loan.loanApplicationId}${
          loan.loanApplicationId ? "?isApplication=true" : ""
        }`}>
                {  loan.loanApplicationId}</Link>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {loan.name || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {formatDate(loan.date)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatAmount(loan.requestedLoanAmount||loan.loanAmount)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full 
                      ${loan.status === 'active'
                        ? 'bg-green-100 text-green-800'
                        : loan.status === 'complete'
                        ? 'bg-blue-100 text-blue-800'
                        : 'bg-gray-100 text-gray-800'
                      }`}
                  >
                    {loan.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatDate(loan.repaymentDate)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
  <button
    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
    onClick={() =>
      navigate(
        `/loans/${loan.loanApplicationId}${
          loan.loanApplicationId ? "?isApplication=true" : ""
        }`
      )
    }
  >
    View
  </button>
</td>


              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default memo(LoansTable);
